import { handoffToEditorLogin } from "../ui/auth/xrhubAuthHandoff.js";
import { AUTH_MODE_INSTANT, resolveAuthMode } from "./reauthHints.js";

export async function handleWidgetReauthFailure({
  storage = localStorage,
  location = window.location,
  clearAuthCookie = () => {},
  xrhubUrl = "",
  creatorBasePath = "",
  auth0Redirect = "",
  useLocalLogin = false,
  loginWithRedirect = null
} = {}) {
  const authMode = resolveAuthMode(storage);
  if (authMode === AUTH_MODE_INSTANT) {
    return false;
  }

  storage.removeItem("auth0token");
  clearAuthCookie();

  await handoffToEditorLogin({
    location,
    xrhubUrl,
    creatorBasePath,
    auth0Redirect,
    useLocalLogin,
    loginWithRedirect,
    persistReturnTo: returnTo => storage.setItem("returnTo", returnTo),
    navigate: url => location.assign(url)
  });

  return true;
}
